import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Router } from 'react-router-dom'
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import history from './helpers/history';

// Styles
import './styles/index.css';
import './styles/App.css';

ReactDOM.render((
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>
), document.getElementById('root'));

unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js